export enum Buttons {
  LEFT_MOUSE = 1 << 0,
  RIGHT_MOUSE = 1 << 1,
  MIDDLE_MOUSE = 1 << 2,
  BACK_MOUSE = 1 << 3,
  FORWARD_MOUSE = 1 << 4,
}
